import { jsx } from "panel";
import { ButtonTheme } from "common/components/button/constants";
import { SkeletonListRowSize } from "common/components/skeleton-list/types";
import { SkeletonListEl } from "common/components/skeleton-list";
import { ButtonEl } from "common/components/button";
import { ItemsMenuEl } from "common/components/items-menu";
import { MenuSearchBar } from "../mixins/search";
import { createContextPanelEventHandlers } from "./context-panel";
export function template() {
  const canUseImprovedQbMenus = this.canUseImprovedQbMenus();
  const isLoading = this.getContext(`metrics`).isLoadingAll();
  const CreateButton = /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".create-custom-button",
    attrs: {
      "show-preview-tooltip": false,
      theme: canUseImprovedQbMenus ? ButtonTheme.Tertiary : ButtonTheme.MenuFooter,
      icon: canUseImprovedQbMenus ? `plus` : ``,
      "hide-input-focus-styling": true,
      label: canUseImprovedQbMenus ? `` : `Create Custom`
    },
    on: {
      click: () => this.handleClickCreate()
    }
  }, !canUseImprovedQbMenus && /* @__PURE__ */ jsx("div", {
    sel: ".create-custom-label",
    attrs: { elref: `label` }
  }, "Create Custom"));
  const InnerSearch = /* @__PURE__ */ jsx(MenuSearchBar, {
    value: this.state.searchFilter,
    handleSearchInput: (value) => this.update({ searchFilter: value }),
    onInsert: (el) => this.update({ keydownProxyEl: el }),
    placeholder: "Search Formulas",
    isBetaMenu: canUseImprovedQbMenus
  }, canUseImprovedQbMenus && CreateButton);
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-formulas-menu",
    class: { "mp-child-menu": true, "beta-menu": canUseImprovedQbMenus },
    hook: { insert: (vnode) => this.helpers.setChildMenuRef(vnode) }
  }, this.attr(`open`) && /* @__PURE__ */ jsx(null, null, InnerSearch, isLoading ? /* @__PURE__ */ jsx(SkeletonListEl, {
    attrs: { "num-rows": 6, "row-size": SkeletonListRowSize.Large },
    sel: ".mp-formulas-menu-skeleton-list"
  }) : /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".mp-formulas-menu-items-menu",
    attrs: {
      elref: `mainSelectionMenu`,
      "empty-message": `No items found`,
      multiple: false,
      "search-filter": this.state.searchFilter,
      "disable-search-sort": true,
      "disable-search-filter-matching-parts": true,
      "disable-first-item-padding": true
    },
    on: {
      click: (ev) => ev.stopPropagation(),
      clickItem: (ev) => this.handleClickItem(ev),
      ...createContextPanelEventHandlers({
        availableContexts: {
          metrics: this.getContext(`metrics`)
        }
      })
    },
    props: {
      sections: this.getSections(),
      keydownProxyEl: this.state.keydownProxyEl,
      contextPanelTransform: (item) => {
        return item.value.id ? this.getTooltipData(item.value.id) : null;
      },
      contextPanelPositionParentElement: this.helpers.getChildMenuRef(),
      sectionsFromInputFn: this.sectionsFromInput
    }
  }), !canUseImprovedQbMenus && CreateButton));
}
